<template>
  <div class="relabel-jobs-button">
    <v-badge
      :content="count"
      :model-value="count > 0"
      color="primary"
      overlap
    >
      <v-btn
        icon
        size="small"
        variant="outlined"
        rounded="circle"
        :color="count > 0 ? 'primary' : 'grey'"
        :title="$t('myboxes.relabel_jobs.title')"
        @click="openModal"
      >
        <v-icon size="small">fas fa-list-ul</v-icon>
      </v-btn>
    </v-badge>

    <relabel-in-filter-jobs-modal
      v-if="showModal"
      ref="jobsModal"
      @close_modal="closeModal"
      @updated="refresh"
    />
  </div>
</template>

<script>
import RelabelInFilterJobsModal from '@/components/myboxes/RelabelInFilterJobsModal.vue';

export default {
  name: 'RelabelInFilterJobsButton',
  components: { RelabelInFilterJobsModal },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    count() {
      return this.$store.getters['project_live_jobs/relabel_count'];
    },
  },
  async mounted() {
    await this.$store.dispatch('project_live_jobs/ensure_subscribed');
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    async refresh() {
      await this.$store.dispatch('project_live_jobs/fetch_active');
      await this.$nextTick();
      this.$refs.jobsModal?.refresh?.();
    },
  },
};
</script>

<style scoped>
.relabel-jobs-button {
  display: inline-flex;
  flex-shrink: 0;
  margin-left: 2px;
}
</style>
